import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { giphyDarkestGrey, giphyLightestGrey, giphyWhite } from '@giphy/js-brand'

const GlobalStyle = createGlobalStyle`
    body {
        margin-top: 125px;
    }
`

const StyledHeader = styled.div`
    z-index: 2;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 125px;
    background-color: ${giphyDarkestGrey};
    box-shadow: inset 0px -8px 20px 0px rgba(0, 0, 0, 0.29);
`

const BackButton = styled.div`
    position: absolute;
    top: 0;
    left: 25px;
    color: ${giphyWhite};
    font-size: 17px;
    font-weight: bold;
    height: 125px;
    line-height: 125px;
`

const MainText = styled.div`
    text-align: center;
    margin: 35px auto 0 auto;
    width: 1080px;
`

const Title = styled.div`
    font-family: NexaBlack;
    font-size: 28px;
    background: rgb(154, 51, 254);
    background: linear-gradient(135deg, rgba(154, 51, 254, 1) 0%, rgba(253, 101, 99, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const Subtitle = styled.div`
    font-size: 14px;
    font-weight: bold;
    color: ${giphyLightestGrey};
`

const BackArrow = styled.span`
    vertical-align: middle;
    margin-right: 15px;
`

type Props = {
    title: string
    subtitle: string
}

const Header = ({ title, subtitle }: Props) => (
    <>
        <GlobalStyle />
        <StyledHeader>
            <BackButton>
                <a href="/supercut">
                    <BackArrow className={'ss-navigateleft'} />
                    Back to library
                </a>
            </BackButton>
            <MainText>
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
            </MainText>
        </StyledHeader>
    </>
)

export default Header
